import React from 'react';
import cx from 'classnames';
import {LayoutContext} from '../ProductPageApp/ProductPageApp';
import s from './ProductName.scss';

export interface ProductNameProps {
  name: string;
}

export class ProductName extends React.Component<ProductNameProps> {
  public render(): JSX.Element {
    return (
      <LayoutContext.Consumer>
        {(layoutName) => (
          <h1 data-hook="product-title" className={cx(s.productName, s[`productName__${layoutName}`])}>
            {this.props.name}
          </h1>
        )}
      </LayoutContext.Consumer>
    );
  }
}
